import type { CoverSheetConfigCard } from '../../../types';

export const buyersAgentCard = {
  id: 'buySideContacts.dualRepBuyersAgent',
  fields: {},
} satisfies CoverSheetConfigCard;
